import {getOutlet} from 'reconnect.js';
import Config from '../../../data.json';

export function getAdminRoutes() {
  const config = getOutlet('config');

  return [
    {name: '首頁', path: '/admin/'},
    // {name: '會員', path: '/admin/users/'},
    {
      name: '會員管理',
      path: '__group-user',
      subroutes: [
        {name: '所有會員', path: '/admin/users/'},
        {name: '帳號刪除申請', path: '/admin/delete_request/'},
      ],
    },
    {
      name: '療程',
      path: '__group-treatment',
      subroutes: [
        {name: '所有療程', path: '/admin/products/'},
        // {name: '客戶已購療程(mock)', path: '/admin/treatment_process/'},
        // {name: '待回報項目(mock)', path: '/admin/pending_report/'},
        {name: '術後照片', path: '/admin/post_operation_report/'},
      ],
    },
    {name: '文章', path: '/admin/articles/'},
    {name: '預約', path: '/admin/appointment/'},
    {
      name: '診所',
      path: '__group-branch',
      subroutes: [
        {name: '所有診所', path: '/admin/branch/'},
        {name: '已綁定診所', path: '/admin/related_branch/'},
        // {name: '診所醫生(mock)', path: '/admin/branch_user/'},
      ],
    },
    {name: '推播', path: '/admin/push_notifications/'},
    // {name: '問卷(mock)', path: '/admin/surveys/'},
    // {name: '常見問題', path: '/admin/faq'},
    {name: '網站設定', path: '/admin/site/'},
    // {name: '頁面建置(Beta)', path: '/admin/pages'},
    /*
    {name: '前台手動更新', path: '/admin/rebuild-history'},
    {
      name: '上傳工具',
      path: '__group-uploader',
      subroutes: [
        {name: '圖片上傳', path: 'image-uploader'},
        {name: '檔案上傳', path: 'file-uploader'},
      ],
    },
    */
    // {name: '客戶諮詢', path: '/admin/customer-support'},
    {name: '重設密碼', path: 'reset-password'},
    {name: '登出', path: 'logout'},
  ];
}
